import {
    toggleRefinement,
    hierarchicalMenu,
    rangeSlider,
    rangeInput,
    menuSelect,
    refinementList
} from 'instantsearch.js/es/widgets';

import textAndImage from './TextAndImageWidget';

/**
 * Widgets.
 * @type {Map<String, Function>}
 */
const widgets = new Map;

widgets.set('toggleRefinement', toggleRefinement);
widgets.set('hierarchicalMenu', hierarchicalMenu);
widgets.set('rangeSlider', rangeSlider);
widgets.set('rangeInput', rangeInput);
widgets.set('menuSelect', menuSelect);
widgets.set('refinementList', refinementList);
widgets.set('textWithImage', textAndImage);

export default widgets;
